import { colors } from "@/utils/const";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import SectionTopLine from "../section-top-line";
import Form from "../Form.jsx";
import OutImgSection from "../out-img-section";
import CustomText from "../text";
import { useI18n } from "@/i18n/I18nProvider";

export default function ApplyProduct({
  img,
  title,
  titleType,
  description,
  descType,
  formType,
  product,
  source,
  shadow = false,
  shadowBottom = -50,
}) {
  const { locale } = useI18n();
  const isArabic = locale === "ar";

  return (
    <Box sx={{ bgcolor: colors.navy, overflowX: "hidden" }} id="apply-form">
      <SectionTopLine img="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-line.svg" />

      <Box className="horizontal-safe-padding vertical-safe-padding">
        <Grid
          container
          spacing={{ xs: 4, lg: 6 }}
          sx={{
            flexDirection: { xs: "column-reverse", md: "row" },
            position: "relative",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: "relative",
              zIndex: 3,
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Form
              type={formType}
              product={product}
              source={source}
              customStyle={{ width: "100%" }}
              newBtn
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: "relative",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                position: "relative",
                zIndex: 2,
                mb: { xs: 3, md: 4 },
              }}
            >
              <CustomText
                text={title}
                type="xl"
                customStyle={{
                  color: colors.dark_yellow,
                  fontWeight: "700",
                  mb: 1,
                  lineHeight: 1,
                }}
                variant={titleType}
              />
              <CustomText
                text={description}
                type="l"
                customStyle={{ color: colors.white }}
                variant={descType}
              />
            </Box>
            <Box
              data-aos={isArabic ? "fade-left" : "fade-right"}
              data-aos-delay="500"
              sx={{
                position: "relative",
                display: "inline-block",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: shadowBottom,
                  left:
                    locale === "ar"
                      ? { xs: "60%", md: "80%", lg: "60%" }
                      : { xs: "50%", md: "15%", lg: "50%" },
                  right: "auto",
                  transform: "translateX(-50%)",
                  width: "1024px",
                  height: "130px",
                  background:
                    "radial-gradient(50% 50% at 50% 50%, #000 0%, rgba(0, 0, 0, 0.00) 100%)",
                  filter: "blur(6px)",
                  zIndex: 0,
                  borderRadius: "1024",
                  opacity: !shadow ? "0" : "0.6",
                },
              }}
            >
              {" "}
              <OutImgSection
                img={img}
                altImg={title}
                side={isArabic ? "right" : "left"}
                customStyle={{
                  transform: {
                    xs: isArabic
                      ? "translateX(5%) scaleX(-1)"
                      : "translateX(-5%) scaleX(1)",
                    sm: isArabic
                      ? "translateX(80px) scaleX(-1)"
                      : "translateX(-80px) scaleX(1)",
                    md: isArabic
                      ? "translateX(0%) scaleX(-1)"
                      : "translateX(0%) scaleX(1)",
                  },
                  pointerEvents: "none",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
